import './styles/fonts.css';
import './styles/main.css';
import { NavigationManager } from './dsl/NavigationManager';
const root = document.getElementById('app');
if (!root) {
    throw new Error('#app root element not found');
}
new NavigationManager(root).start();
